export const getEnvironment = () => {
  const { host } = window.location
  switch (true) {
    // case !!host.match(/k8s.gogoro.cc$/):
    //   return 'k8s';
    case !!host.match(/gogoro.com.ph$/):
      return "globe_production"
    case !!host.match(/globe.gogoro.cc$/):
      return "globe_staging"
    case !!host.match(/globe.qa.gogoro.cc$/):
      return "globe_regression"
    case !!host.match(/globe.dev.gogoro.cc$/):
      return "globe_develop"
    case !!host.match(/qa.gogoro.cc$/):
    case !!host.match(/qa.ss.dev.gogoro.cc$/):
      return "regression"
    case !!host.match(/^dev-/):
    case !!host.match(/dev.gogoro.cc$/):
    default:
      return "develop"
    case !!host.match(/^pa-/):
    case !!host.match(/gogoro.cc$/):
      return "staging"
    case !!host.match(/gogoro.com$/):
      return "production"
  }
}

export const environment = process.env.REACT_APP_ENVIRONMENT || getEnvironment()

export const inLocalDevelopment =
  process.env.NODE_ENV === "development" || window?.location?.host?.match(/(\.localhost:?\d*$|^local(-|host))/)

// 配件小圖來源為正式機
const accessoryAwsUrlMap = {
  develop: "//images.gogoroapp.com/store/",
  regression: "//images.gogoroapp.com/store/",
  staging: "//images.gogoroapp.com/store/",
  production: "//images.gogoroapp.com/store/",
  globe_develop: "//images.gogoroapp.com/store/",
  globe_regression: "//images.gogoroapp.com/store/",
  globe_staging: "//images.gogoroapp.com/store/",
  globe_production: "//images.gogoroapp.com/store/",
}

export const accessoryAwsUrl = inLocalDevelopment ? "//images.gogoroapp.com/store/" : accessoryAwsUrlMap[environment]

const modelStoreHostMap = {
  develop: "dev-store.gogoro.com",
  regression: "dev-store.gogoro.com",
  staging: "dev-store.gogoro.com",
  production: "store.gogoro.com",
  globe_develop: "dev-store.gogoro.com",
  globe_regression: "dev-store.gogoro.com",
  globe_staging: "dev-store.gogoro.com",
  globe_production: "dev-store.gogoro.com",
}

export const modelStoreHost = modelStoreHostMap[environment]

export const dataCompanyMap = {
  develop: "ZpLbxNQK",
  regression: "ZpLbxNQK",
  globe_develop: "ZpLbxNQK",
  globe_regression: "ZpLbxNQK",
  staging: "ZpLbxNQK",
  production: "KDeZL8wy",
  globe_staging: "ZpLbxNQK",
  globe_production: "KDeZL8wy",
}
// TODO merge this map into dataCompanyMap
export const dataCompanyGlobeMap = {
  develop: "4Rg0E2N5",
  regression: "4Rg0E2N5",
  globe_develop: "4Rg0E2N5",
  globe_regression: "4Rg0E2N5",
  staging: "6mQqV8mY",
  production: "LMoy6b3V",
  globe_staging: "6mQqV8mY",
  globe_production: "LMoy6b3V",
}
